import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  CREATE: 'CREATE_PROJECT_INVITATION',
  LIST: 'LIST_PROJECT_INVITATION',
  REVOKE: 'REVOKE_PROJECT_INVITATION',
  ACCEPT: 'APPROVE_PROJECT_INVITATION',
  REJECT: 'REJECT_PROJECT_INVITATION',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT_INSPECTION',
};

export const acceptProjectInvitation = invId => {
  return {
    type: ACTION.ACCEPT,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT_INVITATION}${invId}/accept/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const rejectProjectInvitation = invId => {
  return {
    type: ACTION.REJECT,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT_INVITATION}${invId}/reject/`,
    }).catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const revokeProjectInvitation = invId => {
  return {
    type: ACTION.REVOKE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_PROJECT_INVITATION}${invId}/revoke/`,
    }).then(() => ({ id: invId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createProjectInvitation = (projectId, inviteeId) => {
  const params = {
    project_id: projectId,
    invitee_id: inviteeId,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_INVITATION,
      data: params,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const listProjectInvitation = (pageSize, page, sorted, filtered, invitee_id, inviter_id, status=null) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_INVITATION,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sorted => sorted.desc ? `-${sorted.id}` : sorted.id ).join(',')
          : null,
        invitee_id,
        inviter_id,
        status,
      },
    }),
  };
};



// WEBPACK FOOTER //
// ./src/redux/project_inv/project_inv_actions.js